import React from "react";
import {Form, Input} from 'antd';
import NHFormItem from '../../common/NHFormItem';

/**
 * @author yangqizhi
 * @Description: 地图坐标编辑表单
 */
class EditForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
        }
    }

    static defaultProps = {
        initFormData: {
            isUpdate: false
        }
    };

    componentDidMount() {

    }

    render() {
        const {form} = this.props;
        const initData = this.props.initFormData;
        return (
            <div>
                <Form layout="horizontal">
                    <NHFormItem id={'zbmc'} label={'坐标名称'} form={form} required={true}
                                initialValue={initData.zbmc ? initData.zbmc : ""}>
                        <Input placeholder="请输入坐标名称"/>
                    </NHFormItem>
                    <NHFormItem id={'jd'} label={'经度'} form={form} hasFeedback={true}  required={true}
                                pattern={{
                                    pattern: /^[\-\+]?(0(\.\d{1,10})?|([1-9](\d)?)(\.\d{1,10})?|1[0-7]\d{1}(\.\d{1,10})?|180\.0{1,10})$/,
                                    message: '请输入正确的经度！'}}
                                initialValue={initData.jd}>
                        <Input placeholder="请输入经度"/>
                    </NHFormItem>
                    <NHFormItem id={'wd'} label={'纬度'} form={form} hasFeedback={true}  required={true}
                                pattern={{
                                    pattern: /^[\-\+]?((0|([1-8]\d?))(\.\d{1,10})?|90(\.0{1,10})?)$/,
                                    message: '请输入正确的纬度！'}}
                                initialValue={initData.wd}>
                        <Input placeholder="请输入纬度"/>
                    </NHFormItem>
                    <NHFormItem id={'bz'} label={'坐标备注'} form={form}
                                initialValue={initData.bz ? initData.bz : ""}>
                        <Input placeholder="请输入坐标备注"/>
                    </NHFormItem>
                </Form>
            </div>
        );
    }
}

const editForm = Form.create()(EditForm);

export default editForm;



// WEBPACK FOOTER //
// ./components/fwwgl/dtzbwh/EditForm.js